import React from "react"
import { useSelector } from "react-redux"
import Tags from "@root/components/Tags"
import { useAppDispatch } from "@root/store"
import { selectChannelTags } from "@root/store/selectors"
import { addChannelTag, removeChannelTag } from "@root/store/thunks"
import { Tag } from "@root/store/types"

export interface Props {}

const ChannelTags: React.FC<Props> = () => {
  const tags = useSelector(selectChannelTags)
  const dispatch = useAppDispatch()

  const addTag = React.useCallback(
    (tag: Tag) => {
      dispatch(addChannelTag(tag))
    },
    [dispatch]
  )

  const removeTag = React.useCallback(
    (tag: Tag) => {
      dispatch(removeChannelTag(tag))
    },
    [dispatch]
  )

  return <Tags tags={tags} onAddTag={addTag} onRemoveTag={removeTag} />
}

export default ChannelTags
